import { AHIcon, AHSeparator, Box, ListItem, useLayoutContext } from "arkh";
import React from "react";
import { KPISectionListItem } from "./KPISectionListItem";
import { KPIAddSubSectionButton } from "./KPIAddSubSectionButton";
import { KPITeamGroup } from "../Edit/KPITeamGroup";
import { SectionSubItemContainer } from "./SectionSubItemContainer";
import { Platform } from "react-native";
import * as Haptics from "expo-haptics";

export function TeamGroupItem(props: {
  item: KPITeamGroup;
  isFirst?: boolean;
  isLast?: boolean;
  selected: boolean;
  setSelectedTeams: (
    update: KPITeamGroup[] | ((sections: KPITeamGroup[]) => KPITeamGroup[])
  ) => void;
  openCreateSubSectionBottomSheet(): void;
}) {
  const layout = useLayoutContext();
  return (
    <Box
      cornerRadiusTopLeft={props.isFirst ? "large" : "none"}
      cornerRadiusTopRight={props.isFirst ? "large" : "none"}
      cornerRadiusBottomLeft={props.isLast ? "large" : "none"}
      cornerRadiusBottomRight={props.isLast ? "large" : "none"}
      borderColor="border-primary"
      color="surface"
      space="none"
      style={{
        flexDirection: "column",
        borderWidth: 1,
        borderTopWidth: props.isFirst ? 1 : 0,
        borderBottomWidth: props.isLast ? 1 : 0,
        overflow: "hidden",
      }}
    >
      <KPISectionListItem
        team={{
          id: props.item.teamId,
          color: props.item.color,
          icon: props.item.icon,
          name: props.item.name,
        }}
        onPress={() => {
          if (Platform.OS === "ios") {
            Haptics.selectionAsync();
          }
          if (props.selected) {
            props.setSelectedTeams((teamGroups) =>
              teamGroups.filter(({ teamId: id }) => id !== props.item.teamId)
            );
          } else {
            props.setSelectedTeams((teamGroups) => [...teamGroups, props.item]);
          }
        }}
        style={{
          paddingBottom:
            props.item.subTeams.length > 0 ? 0 : layout.space.medium,
          minHeight: 0,
        }}
      >
        {props.item.subTeams.length === 0 ? (
          <ListItem.MultiSelectIndicator selected={props.selected} />
        ) : null}
      </KPISectionListItem>
      {props.item.subTeams.map((subTeam, index) => (
        <Box
          key={subTeam.sectionId ?? index}
          spaceHorizontal="medium"
          style={{ flex: 1, flexDirection: "row" }}
        >
          <SectionSubItemContainer
            key={index}
            color={props.item.color}
            isLast={index === props.item.subTeams.length - 1}
          >
            <KPISectionListItem
              style={{ paddingLeft: layout.space.small, paddingRight: 0 }}
              name={subTeam.name}
              onPress={() => {
                props.setSelectedTeams((selectedTeams) =>
                  selectedTeams.map((teamGroup) =>
                    teamGroup.teamId === props.item.teamId
                      ? {
                          ...teamGroup,
                          subTeams: teamGroup.subTeams.filter(
                            (_, idx) => index !== idx
                          ),
                        }
                      : teamGroup
                  )
                );
              }}
            >
              <AHIcon type="minus" color="negative" size="medium" />
            </KPISectionListItem>
            <AHSeparator />
          </SectionSubItemContainer>
        </Box>
      ))}
      {props.item.subTeams.length > 0 ? (
        <SectionSubItemContainer
          key={props.item.teamId + "-add-sub-section"}
          color={undefined}
          spaceLeft="medium"
        >
          <KPIAddSubSectionButton
            spaceVertical="medium"
            onPress={props.openCreateSubSectionBottomSheet}
          />
        </SectionSubItemContainer>
      ) : null}
    </Box>
  );
}
